import { EmptyState } from '@monorepo/shared/componentsV2/EmptyState';
import { FullScreenLoadingPage } from '@monorepo/shared/componentsV2/Loading';
import { useDisableSubnav } from '@monorepo/shared/hooks/subnav/useDisableSubnav';
import { getPathToInspections } from '@monorepo/shared/routing';
import { FormTemplateResponse } from 'mapistry-shared';
import React, { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom-v5-compat';
import { FormTemplateEditor } from '../FormTemplateEditor/FormTemplateEditor';
import { FormTemplateUsage } from './FormTemplateUsage';
import { useFormTemplate } from './hooks/useFormTemplate';
import { useSaveEditedFormTemplate } from './hooks/useSaveEditedFormTemplate';

export function EditFormTemplatePage() {
  useDisableSubnav();
  const { organizationId, formTemplateSlug, projectId } = useParams();
  const [isDirty, setIsDirty] = useState(false);
  const closeUrl = getPathToInspections(organizationId, projectId);

  const { formTemplate: fetchedFormTemplate, isLoading } = useFormTemplate({
    slug: formTemplateSlug,
    organizationId,
  });

  const [saveEditedFormTemplate, { isLoading: isSubmitting }] =
    useSaveEditedFormTemplate({ setIsDirty });

  const handleSaveFormTemplate = useCallback(
    async (formTemplate: FormTemplateResponse) => {
      if (!organizationId) return;
      await saveEditedFormTemplate({
        organizationId,
        formTemplate,
        formTemplateId: formTemplate.id,
      });
    },
    [organizationId, saveEditedFormTemplate],
  );

  if (isLoading) return <FullScreenLoadingPage />;

  return !fetchedFormTemplate ? (
    <EmptyState primaryText="There was a problem loading the form." />
  ) : (
    <FormTemplateEditor
      isDirty={isDirty}
      setIsDirty={setIsDirty}
      beginningFormTemplate={fetchedFormTemplate}
      titleVerb="Editing"
      isSubmitting={isSubmitting}
      handleSaveFormTemplate={handleSaveFormTemplate}
      closeUrl={closeUrl}
      sidebarComponent={
        <FormTemplateUsage formTemplateUsage={fetchedFormTemplate?.usage} />
      }
    />
  );
}
